import React from 'react';

const Footer = () => {

    // const [number, setNumber] = useState(12);
    //
    // useEffect(() =>{
    //     const interval = setInterval(
    //         () => setNumber(Math.floor(Math.random() * 100 + 2)),
    //         5000
    //     );
    //      return () => {
    //   clearInterval(interval);
    // };
    // }, [])

    return (
        <React.Fragment>
            <div className="dnw-footer">
                <div className="dnw-footer-l">
                    <div className="dnw-footer-r">
                        <div className="dnw-footer-body">
                            <table width="100%" border="0" cellSpacing="0" cellPadding="0">
                                <tbody>
                                <tr>
                                    <td>
                                        <div><p>
                                            &nbsp;</p>
                                            {/*<table border="0" style={{width: "100%"}}>*/}
                                            {/*    <tbody>*/}
                                            {/*    <tr>*/}
                                            {/*        <td style={{textAlign: "center", hieght: '50px'}}>*/}
                                            {/*            <p>*/}
                                            {/*                    <span style={{color: "rgb(128,128,128)"}}>*/}
                                            {/*                        <span style={{fontFamily: 'times new roman'}}>*/}
                                            {/*                            <span><strong style={{fontSize: "15px"}}>HỆ THỐNG ĐẠI LÝ VÉ SỐ KIẾN THIẾT THINHNAM</strong></span>*/}
                                            {/*                        </span>*/}
                                            {/*                    </span>*/}
                                            {/*                <span>*/}
                                            {/*            <br />*/}
                                            {/*                        <span style={{color: "rgb(128,128,128)"}}>Trụ sở: 117-119-121 Ngô Tất Tố, Phường 22, Quận Bình Thạnh, TP. HCM*/}
                                            {/*                            <br/>*/}
                                            {/*                            &nbsp; Tel:<span*/}
                                            {/*                                style={{fontSize: "14px"}}><strong>028 6266 2222 - 090 363 7779</strong></span>*/}
                                            {/*                        </span>*/}
                                            {/*                        <br/>*/}
                                            {/*                    <span style={{fontSize: "13px"}}>*/}
                                            {/*                        <span style={{color: "#808080"}}>*/}
                                            {/*                            <span style={{color: "#800000"}}>*/}
                                            {/*                                <strong><span*/}
                                            {/*                                    style={{fontFamily: "Times New Roman"}}>ĐỔI SỐ TRÚNG ĐẶC BIỆT</span></strong>*/}
                                            {/*                            </span>*/}
                                            {/*                        </span>*/}
                                            {/*                        <strong><span*/}
                                            {/*                            style={{color: "#808080"}}> Hotline: </span>*/}
                                            {/*                            <span*/}
                                            {/*                                style={{color: "#b22222"}}>0973 777779</span>*/}
                                            {/*                        </strong>*/}
                                            {/*                    </span>*/}
                                            {/*                    </span>*/}
                                            {/*            </p>*/}
                                            {/*        </td>*/}
                                            {/*        <td height="50" style={{textAlign: "center"}}>*/}
                                            {/*            <p>*/}
                                            {/*                    <span style={{color: 'rgb(128,128,128)'}}>*/}
                                            {/*                        <span style={{fontSize: '13px'}}><strong>Công Ty TNHH MTV ĐẠI LÝ XỔ SỐ THINHNAM</strong></span>*/}
                                            {/*                    </span><br/>*/}
                                            {/*                <span style={{color: 'rgb(128,128,128)'}}>*/}
                                            {/*                        <span style={{fontSize: '14px'}}>*/}
                                            {/*                            <strong>*/}
                                            {/*                                <span>THINHNAM Lottery Agent Company Limited<br/>*/}
                                            {/*                                MST: 0314553284 - Tel: +8428 6266 2222 - 0973777779<br/>*/}
                                            {/*                                117-119-121 Ngo Tat To Street, 22 Ward, Binh Thanh Dist, HCM City, Vietnam.*/}
                                            {/*                                </span>*/}
                                            {/*                            </strong>*/}
                                            {/*                        </span>*/}
                                            {/*                    </span>*/}
                                            {/*            </p>*/}
                                            {/*        </td>*/}
                                            {/*    </tr>*/}
                                            {/*    </tbody>*/}
                                            {/*</table>*/}
                                            <div style={{textAlign: "center", fontSize: "12px"}}>
                                                <a href="/"><br/>
                                                    Điều khoản sử dụng</a> | <a charSet="Xổ Số Minh Ngọc™" className="Xổ Số Minh Ngọc™"
                                                     href="/" id="Xổ Số Minh Ngọc™" name="Xổ Số Minh Ngọc™"
                                                     title="Xổ Số Minh Ngọc™"
                                                     type="Xổ Số Minh Ngọc™">www.thinhnamnet.com</a></div>
                                            <p>
                                                &nbsp;</p>
                                            <div className='footer-module'>
                                                <a className="SE"
                                                   href="/"
                                                   jsname="RFGGw"
                                                >Xem trên Tìm kiếm</a>&nbsp; |&nbsp;&nbsp;
                                                <a
                                                className="SE" href="/" jsname="yKrPze"
                                            > Xem trên Google </a>&nbsp;|&nbsp;<a
                                                className="SE" href="/"
                                                jsname="yKrPze"
                                            > Chỉ đường đến XỔ SỐ THINHNAM - ĐỔI SỐ TRÚNG</a>
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                &nbsp;
                                            </div>
                                            <div style={{textAlign: "center"}}>
                                                Copyright &copy; 2018 - 2022 Thinhnam&trade; All right
                                                Reserved. Copyright © <a href="/">sanjidaifi628@gmail.com</a><br/>
                                                &nbsp;
                                            </div>
                                            {/*<div style={{textAlign: "center"}}>*/}
                                            {/*    Tag: xs | xo so | xo so minh ngoc | xs minh ngoc | minhngoc |*/}
                                            {/*    xsminhngoc | kqxs minh ngoc | xsmn | minh ngoc net | minhngoc.net.vn*/}
                                            {/*    | minhngoc.website*/}
                                            {/*    | minh ngoc com | xosominhngoc*/}
                                            {/*</div>*/}
                                            {/*<div style={{textAlign: "center"}}>*/}
                                            {/*    &nbsp;*/}
                                            {/*</div>*/}
                                            <div className="clear"/>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            {/*<div className="dailog_bog"/>*/}
                            {/*<div align="center">Lượt xem :26264{number}</div>*/}
                        </div>
                    </div>
                </div>
            </div>

            <script>

            </script>

        </React.Fragment>
    )
};

export default Footer;
